<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"
          transition="scale-transition"
          width="40"
        />

        <v-img
          alt="Vuetify Name"
          class="shrink mt-1 hidden-sm-and-down"
          contain
          min-width="100"
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-name-dark.png"
          width="100"
        />
      </div>

      <v-spacer />


      <v-btn icon @click="$emit('logout')">
        <v-icon>mdi-export</v-icon>
      </v-btn>
    </v-app-bar>

    <v-content>
      <slot />
    </v-content>
  </v-app>
</template>

<script>

export default {
  name: 'app-layout-default',
};
</script>
